import { fetchWrapper } from '../../utils/request';
import { endpoint } from './endpoint';

export async function requestPaymentChange(
  operationPaymentIds: [string],
  newStartDate: Date,
  comment: string,
  filesIds: Array<IFileId>,
) {
  return fetchWrapper(endpoint + `/v1/change-requests/request-payment-change`, {
    method: 'post',
    body: JSON.stringify({
      operationPaymentIds,
      newStartDate,
      comment,
      filesIds,
    }),
  });
}

export async function rejectRequestChange(id, reason, userReviewData) {
  return fetchWrapper(endpoint + `/v1/change-requests/reject/${id}`, {
    method: 'put',
    body: JSON.stringify({ reason, userReviewData }),
  });
}

export async function rejectPaymentChangeRequest(id) {
  return fetchWrapper(endpoint + `/v1/change-requests/reject-payment/${id}`, {
    method: 'put',
    body: JSON.stringify({ id }),
  });
}

export async function approveRequestChange(id) {
  return fetchWrapper(endpoint + `/v1/change-requests/approve/${id}`, {
    method: 'put',
    body: JSON.stringify({ id }),
  });
}

export async function getRequests() {
  return fetchWrapper(endpoint + `/v1/change-requests`, {
    method: 'get',
  }).then((res) => res.json());
}

export async function finishWithRequest(id) {
  return fetchWrapper(endpoint + `/v1/change-requests/viewed-request/${id}`, {
    method: 'put',
    body: JSON.stringify({ id }),
  });
}

interface IFileId {
  fileName: string;
  fileNameInS3: string;
  fileType: string;
  id: string;
}

interface IRequestChangeLine {
  applicationId: any;
  newApplicationId: any;
  comment: string;
  changedLineIds: Array<string>;
  isNewLines?: boolean;
  filesId?: Array<IFileId>;
}

export async function requestChangeActiveLine(updates: IRequestChangeLine) {
  return fetchWrapper(endpoint + `/v1/change-requests/request-line-change`, {
    method: 'post',
    body: JSON.stringify({ ...updates }),
  }).then((res) => res.json());
}
